import { AutenticacionService } from './autenticacion.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class EstadoCuentaClientesService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;

  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/estado-cuenta-clientes';
    this.service_url = this.api_url + this.modulo_url;
  }

  getObras() {
    return this.http.get(this.service_url + '/obras', this.authService.getAuthHeaders());
  }

  generar(idObra, fechaInicial, fechaFinal, porcentajeHonorarios) {
    const request = this.service_url + '/generar'
      + '?obra=' + idObra
      + '&fechaInicial=' + fechaInicial
      + '&fechaFinal=' + fechaFinal
      + '&porcentajeHonorarios=' + encodeURIComponent(porcentajeHonorarios);
    return this.http.get(request, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/estado-cuenta-clientes.service.ts